/*
 * File: ProductSelectionCard.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 20 Dec 2021 11:59:23 am
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

/* eslint-disable react/react-in-jsx-scope */

import { Col, Form, FormInstance, Input, InputNumber, message, Typography } from 'antd';
import { MessageType } from 'antd/lib/message';
import { SublineForm } from 'components/molecules/AddChildModal';
import { useField } from 'formik';
import { ProductsTableDataSource } from 'models/ProductsTableDataSource';
import { ProductSubType } from 'models/ProductSubType';
import { SalesOrderLineItemModel } from 'models/SalesOrderLineItemModel';
import { useMemo, useState } from 'react';

interface Props {
  record?: ProductsTableDataSource;
  form: FormInstance<SublineForm>;
  index: number;
}



export const SublineProductAdhocCard: React.FC<Props> = ({ record, form, index }: Props): JSX.Element => {
  const [itemId, _setItemId] = useState(''); //AKA PRODUCT NUMBER


  const [x, _, { setValue }] = useField<SalesOrderLineItemModel>(`lines.${index}`);


  const initialValues = {
    quantity: 1,
    itemId: '',
    productDescription: ''
  };

  const isDuplicate = useMemo(() => x.value?.subLines?.some((child) => child.productNumber === itemId), [itemId, x.value, record?.productNumber]);



  const handleAddProduct = (values: typeof initialValues): void | MessageType => {
    const lineItemToAdd: ProductSubType = {
      productNumber: values.itemId ?? '',
      productDescription: values.productDescription ?? '',
      quantity: +values.quantity ?? undefined,
      lineNumber: x?.value?.subLines?.length
    };

    if (!values.quantity) {
      message.error('Quantity has to be greater than 0');
      form.resetFields();
      _setItemId('')


      return;
    }

    if (isDuplicate) {
      message.error('Submodule already exists in table');

      return;
    }


    // TODO: use formik to adhoc a child to the parent product
    setValue({ ...x.value, subLines: x.value.subLines ? [...x.value.subLines, lineItemToAdd] : [lineItemToAdd] });


    form.resetFields();
    _setItemId('')
    message.success('Submodule successfully added');

  };

  return (
    <Form layout="vertical" initialValues={initialValues} onFinish={handleAddProduct} form={form}>
      <Col span={24} style={{ background: '#18a79984', borderRadius: 10, marginBottom: 10 }}>
        <Typography.Title level={4} style={{ fontWeight: 400, fontSize: 20, marginBottom: 0, padding: 10, marginLeft: 10 }}>
          General
        </Typography.Title>
      </Col>
      <Col style={{ margin: '20px 10px' }}>
        <Form.Item
          rules={[
            {
              required: true,
              message: 'Product number is a required field'
            },
            {
              max: 30,
              message: 'Product number cannot be more than 30 characters'
            }
          ]}
          label={<Typography.Paragraph style={{ marginBottom: 0 }}>Product Number</Typography.Paragraph>}
          name={'itemId'}>
          <Input value={itemId} onChange={(e): void => _setItemId(e.target.value)} />
        </Form.Item>
        <Form.Item label={<Typography.Paragraph style={{ marginBottom: 0 }}>Quantity</Typography.Paragraph>} name={'quantity'}>
          <InputNumber style={{ width: '100%' }} min={1} />
        </Form.Item>
        <Form.Item label={<Typography.Paragraph style={{ marginBottom: 0 }}>Description</Typography.Paragraph>} name={'productDescription'}>
          <Input />
        </Form.Item>
      </Col>
    </Form>
  );
};
